<template>
  <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-y transition="scale-transition">
    <v-btn
      :flat="isFlatbutton"
      :icon="!isBigbutton"
      :color="buttonfarbe"
      slot="activator"
      :light="lighttext"
    >Teilen
      <v-icon right>share</v-icon>
    </v-btn>

    <v-card>
      <social-sharing
        :url="'https://www.lokaleshandwerk.de/betrieb/' + this.company.slug"
        :title="this.company.vollername"
        :description="this.company.beschreibung"
        inline-template
      >
        <v-list class="mouseoverlink">
          <network network="email">
            <v-list-tile @click>
              <v-list-tile-avatar>
                <v-icon>alternate_email</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>als Email</v-list-tile-title>
            </v-list-tile>
          </network>
          <network network="facebook">
            <v-list-tile @click>
              <v-list-tile-avatar>
                <v-icon>thumb_up</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>auf Facebook</v-list-tile-title>
            </v-list-tile>
          </network>
          <network network="whatsapp">
            <v-list-tile @click>
              <v-list-tile-avatar>
                <span class="headline">W</span>
              </v-list-tile-avatar>
              <v-list-tile-title>WhatsApp</v-list-tile-title>
            </v-list-tile>
          </network>
          <network network="skype">
            <v-list-tile @click>
              <v-list-tile-avatar>
                <span class="headline">S</span>
              </v-list-tile-avatar>
              <v-list-tile-title>Skype</v-list-tile-title>
            </v-list-tile>
          </network>
          <network network="sms">
            <v-list-tile @click>
              <v-list-tile-avatar>
                <v-icon>message</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>SMS</v-list-tile-title>
            </v-list-tile>
          </network>
        </v-list>
      </social-sharing>
    </v-card>
  </v-menu>
</template>

<script>
// import axios from 'axios'

export default {
  props: {
    id: Number,
    betrieb: String,
    company: Object,
    buttonfarbe: String,
    lighttext: Boolean,
    isBigbutton: Boolean,
    isFlatbutton: Boolean
  },
  data () {
    return {
      show: false,
      dialog: false,
      fav: true,
      menu: false,
      message: false,
      hints: true
    }
  },
  computed: {
    BeschreibungShort: function () {
      var text
      if (this.company.beschreibung) {
        var length = 80

        text = this.company.beschreibung.substring(0, length)
      }
      return text
    }
  }
}
</script>
<style>
.mouseoverlink {
  cursor: pointer;
}
</style>


        